import { Text } from '@rsos/base-components';
import styled from '@rsos/theme/styled';

export const LayerName = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
`;
